import React from 'react';
import './alert-warning-message.scss';
import { WarningIcon } from '../../../../icons/icons';

interface IProps {
    title: string | object;
    message: string | object;
}

const AlertWarningMessage = (props: IProps) => (
    <div className='alert-warning-message'>
        <div className='alert-message alert-message--warning alert-warning-message__header'>
            <WarningIcon className='alert-warning-message__icon' />
            {props.title}
        </div>
        <div className='alert-message alert-warning-message__body'>{props.message}</div>
    </div>
);

export { AlertWarningMessage };
